export default __webpack_public_path__ + "static/connectFeaturedImage-e0d2f9eb21ab98062682ca0e350df917.png";